<div class="modal-header">
  <h4 class="modal-title pull-left">{{'MODALE_DONNEE_SUIVI.EQUIPEMENTS' | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="showModalCancel()" title="{{'GLOBAL.FERMER' | translate}}">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <form id="OperatorForm" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-6 form-group">
        <label for="name">{{'GLOBAL.NOM' | translate}}</label>
        <input type="text" id="name" name="name" class="form-control" [(ngModel)]="equipment.name" [disabled]="$any(equipment).withExternalConnection" />
        @if (equipment?.name == undefined && showError()) {
          <div class="custom-alert custom-alert-sm">{{'GLOBAL.NOM' | translate }}</div>
        }
      </div>
      <div class="col-md-6 form-group">
        <label for="model">{{'GLOBAL.MODEL' | translate}}</label>
        <input type="text" id="model" name="model" class="form-control" [(ngModel)]="equipment.model" disabled />
      </div>
    </div>
    <div class="form-group">
      <label for="equipmentType">Type</label>
      <select id="equipmentType" class="form-control" [(ngModel)]="equipment.typeId" name="typeId" required>
        @for (type of equipmentTypes; track type) {
          <option [value]="type.typeId">{{ type.name }}</option>
        }
      </select>
    </div>
    @if (isDrillType()) {
      <div class="form-group">
        <label for="co2EqPerDrilledMeter">{{'EQUIPMENT.CO2_PER_DRILLED_METER' | translate}}</label>
        <input type="number" id="co2EqPerDrilledMeter" name="co2EqPerDrilledMeter" class="form-control" [(ngModel)]="equipment.co2EqPerDrilledMeter" step="0.01" min="0" />
      </div>
    }
    <div class="btn-toolbar justify-content-between">
      <div class="btn-group" role="group">
        <button type="submit" form="OperatorForm" class="btn btn-outline-success" style="margin-right:10px;">{{'GLOBAL.VALIDER' | translate}}</button>
      </div>
      <div class="btn-group" role="group">
        <button type="button" class="btn btn-secondary" (click)="showModalCancel()">{{'GLOBAL.FERMER' | translate}}</button>
      </div>
    </div>
  </form>
</div>

<div bsModal #modalConfirmSuppr="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_SUPPRESSION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="onDelete()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideConfirmSuppr()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #modalConfirmCancel="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
  <div class="modal-dialog modal-sm">
    <div class="modal-content">
      <div class="custom-overlay"></div>
      <div class="modal-body text-center">
        <p>{{'GLOBAL.CONFIRMATION_ANNULATION' | translate}}</p>
        <button type="button" class="btn btn-primary" (click)="bsModalRef.hide()">{{'GLOBAL.OUI' | translate}}</button>
        <button type="button" class="btn btn-secondary" (click)="hideModalCancel()" style="margin-left: 20px;">{{'GLOBAL.NON' | translate}}</button>
      </div>
    </div>
  </div>
</div>
